const saveForm1262ReturningUserData = require("../../run/form1262/saveForm1262ReturningUserData");
const getForm1262Data = require("../../run/form1262/getForm1262Data");
const submitForm1262DataToMarketo = require("../../run/form1262/submitForm1262DataToMarketo");

/**
 * @param formId {string}
 * @return {void}
 */
module.exports = async function whenForm1262Submits(formId) {
    const formData = getForm1262Data(formId);

    if (formData) {
        await submitForm1262DataToMarketo(formData);
        saveForm1262ReturningUserData(formData);
    }

    throw new Error("Something went wrong!");
};
